import { useEffect } from 'react';

const EVENTS = ['click', 'keydown', 'touchstart', 'mousemove'];

function saveHeartbeat() {
  try {
    localStorage.setItem('last_active_ts', String(Date.now()));
  } catch {
    // ignore storage errors
  }
}

export function useAuthInactivity() {
  useEffect(() => {
    saveHeartbeat();
    EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, saveHeartbeat, { passive: true });
    });

    return () => {
      EVENTS.forEach((eventName) => {
        document.removeEventListener(eventName, saveHeartbeat);
      });
    };
  }, []);
}
